import { Component, inject } from '@angular/core';
import { DistanceService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DistanceCreateDto,
  DistanceDto,
  DistanceExcelDownloadDto,
  DistanceUpdateDto,
} from '../proxy/general/dtos/distance';
import { DISTANCE_CONFIG, DISTANCE_FIELDS } from './distance.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-distance',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DistanceService, ConfirmationService],
  templateUrl: './distance.html',
  styleUrl: './distance.scss',
})
export class Distance extends BaseCrudComponent<
  DistanceDto,
  DistanceCreateDto,
  DistanceUpdateDto,
  DistanceExcelDownloadDto
> {
  service = inject(DistanceService);
  config = DISTANCE_CONFIG;
  fields = DISTANCE_FIELDS;

  protected prepareUpdateDto(data: any, selected: DistanceDto): DistanceUpdateDto {
    return {
      isDefaultDistance: data.isDefaultDistance,
      distanceValue: data.distanceValue,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Distance';
  }
}
